import React from 'react'
import PropTypes from 'prop-types'
import './index.scss'
const Title = ({ history, title }) => {

    const goback = () => {
        history.go(-1)
    }

    return (
        <div className='page-title'>{title}
            {
                history && <span>
                    <a style={{color: "#31d5df"}} onClick={goback}>{`< 返回`}</a></span>
            }
        </div>
    )
}
Title.propTypes = {
    title: PropTypes.string.isRequired
}
export default Title
